/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Sandy_Swan_HowlInputs */

const en_soft_sandy_swan_howl = /** @type {(inputs: Soft_Sandy_Swan_HowlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

const de_soft_sandy_swan_howl = /** @type {(inputs: Soft_Sandy_Swan_HowlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add" |
*
* @param {Soft_Sandy_Swan_HowlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_sandy_swan_howl = /** @type {((inputs?: Soft_Sandy_Swan_HowlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Sandy_Swan_HowlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_sandy_swan_howl(inputs)
	return de_soft_sandy_swan_howl(inputs)
});